(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["aw-dispatch-bar"] && !Shopify.designMode) return;
  try {
    function initializeDispatchBars(){
  const parts=Object.fromEntries(new Intl.DateTimeFormat('en-US',{timeZone:'America/New_York',year:'numeric',month:'numeric',day:'numeric'}).formatToParts(new Date()).filter(p=>p.type!=='literal').map(p=>[p.type,p.value]));
  const next=new Date(Date.UTC(Number(parts.year),Number(parts.month)-1,Number(parts.day)));
  do{next.setUTCDate(next.getUTCDate()+1);}while(next.getUTCDay()===0||next.getUTCDay()===6);
  const dateParts=new Intl.DateTimeFormat('en-GB',{timeZone:'UTC',weekday:'short',day:'numeric',month:'long'}).formatToParts(next);
  const dateValue=type=>dateParts.find(p=>p.type===type).value;
  document.querySelectorAll('[data-dispatch-bar]').forEach(bar=>{
    bar.querySelector('[data-dispatch-date]').textContent=dateValue('weekday')+', '+dateValue('day')+' '+dateValue('month');
    const stock=bar.closest('.product-info')?.querySelector('[data-stock]');
    if(stock){bar.hidden=stock.hidden;new MutationObserver(()=>{bar.hidden=stock.hidden;}).observe(stock,{attributes:true,attributeFilter:['hidden']});}
  });
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',initializeDispatchBars,{once:true});}else{initializeDispatchBars();}
document.addEventListener('shopify:section:load',initializeDispatchBars);
  } catch(e) { console.error(e); }
})();

})();
